/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_favorites_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your favorites`)
};

const es_home_favorites_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus favoritos`)
};

const de_home_favorites_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Favoriten`)
};

const nl_home_favorites_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw favorieten`)
};

const fr_home_favorites_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos favoris`)
};

const it_home_favorites_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi preferiti`)
};

const pt_br2_home_favorites_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus favoritos`)
};

const pt_home_favorites_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os seus favoritos`)
};

const ja_home_favorites_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お気に入り`)
};

const zh_home_favorites_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的收藏`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_favorites_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_favorites_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_favorites_title", locale)
	if (locale === "en") return en_home_favorites_title(inputs)
	if (locale === "es") return es_home_favorites_title(inputs)
	if (locale === "de") return de_home_favorites_title(inputs)
	if (locale === "nl") return nl_home_favorites_title(inputs)
	if (locale === "fr") return fr_home_favorites_title(inputs)
	if (locale === "it") return it_home_favorites_title(inputs)
	if (locale === "pt-BR") return pt_br2_home_favorites_title(inputs)
	if (locale === "pt") return pt_home_favorites_title(inputs)
	if (locale === "ja") return ja_home_favorites_title(inputs)
	return zh_home_favorites_title(inputs)
};